import React from 'react'
import { Field } from 'redux-form'

import { getFields } from '../../../../../utils/steps'

import DynamicInput from '../../../../Shared/Forms/DynamicInput'
import ExpandableField from './ExpandableField'

export default function Fields({
  database,
  tableName,
  emptyPlaceholder,
  actionId,
  stepId,
}) {
  let simpleFields = getFields(database, tableName, { simple: true })
  let expandableFields = getFields(database, tableName, { expandable: true })

  return (
    <div>
      <h2>Fields</h2>
      <div>
        {simpleFields.map(({ displayName, name }) => (
          <Field
            name={`fields.${name}`}
            label={displayName || name}
            key={name}
            component={DynamicInput}
            placeholder={emptyPlaceholder}
            type="text"
            actionId={actionId}
            stepId={stepId}
            databaseId={database.id}
            table={tableName}
            column={name}
          />
        ))}
      </div>
      <div>
        {expandableFields.map(column => (
          <ExpandableField
            field={`fields.${column.name}`}
            label={column.displayName || column.name}
            actionId={actionId}
            stepId={stepId}
            databaseId={database.id}
            table={tableName}
            column={column}
          />
        ))}
      </div>
    </div>
  )
}
